import { Link } from "react-router-dom";
import { Pencil, X } from "lucide-react";
import { ShieldPreview } from "../shield/ShieldPreview";
import { sizeOf, withDefaults } from "../../lib/shield";

const missing = (raw) => { const d = withDefaults(raw); return [!d.photo.file && "photo", Object.values(d.stats).some((v) => v === "") && "stats"].filter(Boolean); };

export const SquadCard = ({ player, svgRef, onRemove, claimed, onRelease }) => (
  <div className="card-lift fade-up group relative border-2 border-slate-200 bg-white p-3" data-testid={`squad-card-${player.id}`}>
    <div className="checker aspect-[406/650] w-full">
      <ShieldPreview ref={svgRef} design={{ ...player.design, guide: false }} testId={`squad-shield-${player.id}`} />
    </div>
    <div className="mt-2 flex items-start justify-between gap-2">
      <div className="min-w-0">
        <div className="truncate font-bold" data-testid={`squad-card-name-${player.id}`}>{player.title}</div>
        <div className="text-xs text-slate-500">{sizeOf(player.design.size).name}</div>
        {missing(player.design).length > 0 && <div className="text-[11px] font-semibold text-amber-700" data-testid={`squad-missing-${player.id}`}>Needs {missing(player.design).join(" & ")}</div>}
        {claimed && (
          <button type="button" onClick={onRelease} className="mt-1 bg-lime-100 px-1.5 py-0.5 text-[10px] font-bold uppercase text-lime-800 hover:bg-lime-200" title="Release to let another parent edit" data-testid={`squad-claimed-${player.id}`}>Parent editing · release</button>
        )}
      </div>
      <Link to={`/d/${player.id}`} className="flex shrink-0 items-center gap-1 border-2 border-slate-900 px-2 py-1 text-xs font-bold uppercase hover:bg-slate-900 hover:text-white" data-testid={`squad-edit-${player.id}`}>
        <Pencil className="h-3 w-3" /> Edit
      </Link>
    </div>
    <button type="button" onClick={onRemove} aria-label="Remove from squad" data-testid={`squad-remove-${player.id}`}
      className="absolute right-2 top-2 bg-white/90 p-1 text-slate-400 opacity-0 transition-opacity hover:text-red-600 group-hover:opacity-100 focus:opacity-100">
      <X className="h-4 w-4" />
    </button>
  </div>
);
